import React from "react"
import { Link as GatsbyLink } from "gatsby"
export default function Link({ href, ...props }) {
  return href.startsWith("/") ? (
    <GatsbyLink to={href} {...props} />
  ) : (
    <a href={href} {...props} />
  )
}
